/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { RevokeInvitationMutationResponse, RevokeInvitationPathParams, RevokeInvitation400, RevokeInvitation401, RevokeInvitation403, RevokeInvitation404, RevokeInvitation409, RevokeInvitation500 } from "../../types/staffController/RevokeInvitation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getRevokeInvitationUrl(organizationId: RevokeInvitationPathParams["organizationId"], invitationId: RevokeInvitationPathParams["invitationId"]) {
  const res = { method: 'DELETE', url: `/api/organizations/${organizationId}/invitations/${invitationId}` as const }
  return res
}

/**
 * @summary Revoke invitation
 * {@link /api/organizations/:organizationId/invitations/:invitationId}
 */
export async function revokeInvitation(organizationId: RevokeInvitationPathParams["organizationId"], invitationId: RevokeInvitationPathParams["invitationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<RevokeInvitationMutationResponse, ResponseErrorConfig<RevokeInvitation400 | RevokeInvitation401 | RevokeInvitation403 | RevokeInvitation404 | RevokeInvitation409 | RevokeInvitation500>, unknown>({ method : "DELETE", url : getRevokeInvitationUrl(organizationId, invitationId).url.toString(), ... requestConfig })
  return res.data
}